// trackingConstants.js
'use strict';

import { CHAT_ID as AUTO_CHAT_CHAT_ID } from '../resource/autoChatConstants.js';
import { Progress as JoinProgress } from '../resource/joinConstants.js';
import { LIVESTREAM_PATH } from '../resource/liveStreamConstants.js';
import {
  ProfileListType,
  ProfileListPublishStatus,
  ManageProfileType,
} from '../resource/profileConstants.js';

export const ButtonId = {
  Landing: {
    ButtonLandingLogin: 'button-landing-login',
    ButtonBirthdayChange: 'button-birthday-change',
    LandingPageCta: 'landing-page-cta',
  },
  All: {
    ButtonHidePassword: 'button-hide-password',
    ButtonDisplayPassword: 'button-display-password',
    ButtonMuted: 'button-muted',
    ButtonVolume: 'button-volume',
    ButtonLogout: 'button-logout',
    ButtonCancel: 'button-cancel',
    ButtonOnlineService: 'button-online-service',
    ButtonDiamondShop: 'button-diamond-shop',
    ButtonGift: 'button-gift',
    ButtonGiftChatroom: 'button-chatroom-gifts',
    ButtonGiftLiveStream: 'button-livestream-gifts',
    ButtonSend: 'button-send',
    ButtonTopUp: 'button-top-up',
    ButtonRecord: 'button-record',
    ButtonMessageSend: 'button-message-send',
    ButtonSettings: 'button-settings',
    ButtonClose: 'button-close',
    ButtonBack: 'button-back',
    ButtonMore: 'button-more',
    ButtonFollow: 'button-follow',
    ButtonUnfollow: 'button-unfollow',
    ButtonChat: 'button-chat',
    ButtonUnlock: 'button-unlock',
    ButtonShare: 'button-share',
    ButtonTempLivestream: 'button-temp-livestream',
    ButtonTempFreezone: 'button-home-freezone',
    ButtonReferralTopUp: 'button-referral-top-up',
    TabStory: 'tab-story',
    TabFlix: 'tab-flix',
    TabImage: 'tab-image',
    TabLeaderboardNow: 'tab-leaderboard-now',
    TabLeaderboardHour: 'tab-leaderboard-hour',
    TabLeaderboardWeek: 'tab-leaderboard-week',
    TabLeaderboardMonth: 'tab-leaderboard-month',
    TabChatroom: 'tab-chatroom',
    ButtonFlixCard: 'button-flix-card',
    ButtonStoryCard: 'button-story-card',
    ButtonCardAvatar: 'button-card-avatar',
    ButtonPostCard: 'button-post-card',
    ButtonLiveStreamCard: 'button-livestream-card',
    ButtonLivestreamMore: 'button-livestream-more',
    ButtonCpCard: 'button-cp-card',
    ButtonKycUnblur: 'button-kyc-unblur',
    ButtonKycSticker: 'button-kyc-sticker',
    ButtonHamburger: 'button-hamburger',
    ButtonExitSWAG: 'button-exit',
    ButtonAgeVerifyBanner: 'button-age-verify-banner',
    ButtonFreeWatch: 'button-free-watch',
    ButtonCheck: 'button-check',
    ButtonSubscribe: 'button-subscribe',
    ButtonUnsubscribe: 'button-unsubscribe',
    ButtonTextTranslate: 'button-text-translate',
    ButtonTextOriginal: 'button-text-original',
    ButtonDelete: 'button-delete',
    ButtonCopyCode: 'button-copy-code',
    ButtonCopyLink: 'button-copy-link',
    ButtonReport: 'button-report',
    ButtonUnblock: 'button-unblock',
    ButtonBlock: 'button-block',
    ButtonDiscard: 'button-discard',
    ButtonProviderRebind: 'button-provider-rebind',
    ButtonRetry: 'button-retry',
    ButtonConfirm: 'button-confirm',
    ButtonNext: 'button-next',
    ButtonEmailEnter: 'button-email-enter',
    ButtonPhoneEnter: 'button-phone-enter',
    ButtonPhoneReward: 'button-phone-reward',
    ButtonUsername: 'button-username',
    ButtonSave: 'button-save',
    ButtonLeave: 'button-leave',
    ButtonSkip: 'button-skip',
    ButtonResubmit: 'button-resubmit',
    ButtonGiftItem: 'button-gift-item',
    ButtonOpenSidebar: 'button-open-sidebar',
    ButtonCloseSidebar: 'button-close-sidebar',
    ButtonHome: 'button-home',
    ButtonLike: 'button-like',
    ButtonDislike: 'button-dislike',
    ButtonSortingOption: 'button-sorting-option',
    ButtonFilter: 'button-filter',
    ButtonSorting: 'button-sorting',
    ButtonFilterDetail: 'button-filter-detail',
    ButtonFilterOption: 'button-filter-option',
    ButtonFilterConfirm: 'button-filter-confirm',
    ButtonFilterReset: 'button-filter-reset',
    ButtonFilterClear: 'button-filter-clear',
    ButtonFilterSuggest: 'button-filter-suggest',
    ClearFilterOptions: 'clear-filter-options',
    ButtonPin: 'button-pin',
    ButtonUnpin: 'button-unpin',
    ButtonHiddenMassage: 'button-hidden-massage',
    ButtonEdit: 'button-edit',
    ButtonVideoClip: 'button-video-clip',
    ButtonExpand: 'button-expand',
    ButtonCollapse: 'button-collapse',
    ButtonPurchase: 'button-purchase',
    ButtonInformation: 'button-information',
    ButtonUserEvent: 'button-user-event',
    ButtonUserBadge: 'button-user-badge',
    ButtonVerifyNow: 'button-verify-now',
    ButtonAvatarClick: 'button-avatar-click',
    ButtonHashtag: 'button-hashtag',
    UserSquareCardName: 'user-square-card-name',
    UserCircleCardName: 'user-circle-card-name',
    ButtonRatingStar: 'button-rating-star',
    ButtonRating: 'button-rating',
    ButtonTheaterMode: 'button-theater-mode',
    ButtonUserMission: 'button-user-mission',
    ButtonMissionCta: 'button-mission-cta',
  },
  Home: {
    ButtonCovergirlFollow: 'button-covergirl-follow',
    ButtonFirstMessageSend: 'button-first-message-send',
    ButtonCovergirlMessageSend: 'button-covergirl-message-send',
    ButtonFirstUnlock: 'button-first-unlock',
    ButtonHomeLeaderboardCard: 'button-home-leaderboard-card',
    ButtonFreeFeedChat: 'button-free-feed-chat',
    ButtonChannelLiveStream: 'button-channel-livestream',
    ButtonSearch: 'button-search',
    ButtonAutoComplate: 'button-autocomplete',
    ButtonChannelFreezone: 'button-channel-freezone',
    ButtonNotificationCenter: 'button-notification-center',
    ButtonHomeTabFeatures: 'button-home-tab-features',
    ButtonHomeTabFeed: 'button-home-tab-feed',
    ButtonHomeTabVideo: 'button-home-tab-video',
    ButtonHomeTabStory: 'button-home-tab-story',
    ButtonTrendingHashtag: 'button-trending-hashtag',
    ButtonHomeBanners: 'button-home-banners',
    ButtonVideoBanners: 'button-video-banners',
    ButtonEventDragonTigerFightGame: 'button-event-dragon-tiger-fight-game',
    ButtonEventGameMenu: 'button-event-game-menu',
    ButtonExploreCampaign: 'button-explore-campaign',
    ButtonSearchVipRecommend: 'button-search-vip-recommend',
  },
  Tab: {
    TabSignup: 'tab-signup',
    TabLogin: 'tab-login',
    TabCategory: 'tab-category',
    TabButtonShorts: 'tab-button-shorts',
    TabButtonDiscover: 'tab-button-discover',
    TabButtonHome: 'tab-button-home',
    TabButtonSearch: 'tab-button-search',
    TabButtonChat: 'tab-button-chat',
    TabButtonProfile: 'tab-button-profile',
    TabButtonCreate: 'tab-button-create',
    TabFlixDetailCp: 'tab-flix-detail-cp',
    TabFlixDetailRecommend: 'tab-flix-detail-recommend',
    TabButtonLivestream: 'tab-button-livestream',
    TabButtonEvent: 'tab-button-event',
    TabLotteryEvent: 'tab-lottery-event',
    TabDatingAssuranceEvent: 'tab-dating-assurance-event',
    TabSearchAll: 'tab-search-all',
    TabSearchVideo: 'tab-search-video',
    TabSearchCreator: 'tab-search-creator',
    TabSearchStory: 'tab-search-story',
    TabSearchHashtag: 'tab-search-hashtag',
    TabButtonFeed: 'tab-button-feed',
    TabButtonHamburger: 'tab-button-hamburger',
    TabButtonLeaderboard: 'tab-button-leaderboard',
    TabFollowing: 'tab-following',
    TabExplore: 'tab-explore',
    TabBrowse: 'tab-browse',
    TabPublished: 'tab-published',
    TabUnpublished: 'tab-unpublished',
  },
  Search: {
    SearchRecentHashtag: 'search-recent-hashtag',
    SearchTrendingHashtag: 'search-trending-hashtag',
    ButtonMoreFlix: 'button-more-flix',
    ButtonMoreCreator: 'button-more-creator',
    ButtonMoreStory: 'button-more-story',
    ButtonMoreHashtag: 'button-more-hashtag',
    ButtonSearchSorting: 'button-search-sorting',
    ButtonSearchCancel: 'button-search-cancel',
  },
  Setting: {
    ButtonDownloadSchatIos: 'button-download-schat-ios',
    ButtonDiamondShop: 'button-diamond-shop',
    ButtonPrepaidSend: 'button-prepaid-send',
    ButtonSwagBlog: 'button-swag-blog',
    ButtonTopup: 'topup-setting-autopay ',
    ButtonRegion: 'button-region',
    ButtonLanguage: 'button-language',
    ButtonLanguageOption: 'button-language-option',
    ButtonProfile: 'button-profie',
    ButtonKYC: 'button-kyc',
    ButtonHamburgerClose: 'button-hamburger-close',
    ButtonHamburgerArchived: 'button-hamburger-archived',
    ButtonAgeVerifyHamburger: 'button-age-verify-hamburger',
    ButtonExchange: 'button-exchange',
    ButtonGetReward: 'button-get-reward',
    ButtonShareDownloadAppLink: 'button-share-download-app-link',
    ButtonSettings: 'button-settings',
    ButtonBindNow: 'button-bind-now',
    ButtonSwagOpening: 'button-swag-opening',
    ButtonDomainHub: 'button-domain-hub',
    ButtonBecomeAModel: 'button-become-a-model',
    ButtonChannelVip: 'button-channel-vip',
    ButtonLogin: 'button-setting-login',
    ButtonLogout: 'button-setting-logout',
    ButtonJournal: 'button-journal',
    ButtonConnectEmail: 'button-connect-email',
    ButtonHamburgerEcommerce: 'button-hamburger-ecommerce',
    ButtonTos: 'button-tos',
    ButtonPrivacyPolicy: 'button-privacy-policy',
    ButtonDrmPanel: 'button-drm-panel',
    ButtonAboutSwag: 'button-about-swag',
    Button2257: 'button-2257',
    ButtonFaq: 'button-faq',
    ButtonContactSupport: 'button-contact-support',
    ButtonDebugPanel: 'button-debug-panel',
    ButtonCareer: 'button-career',
    ButtonSwagInstagram: 'button-swag-instagram',
    ButtonSwagYoutube: 'button-swag-youtube',
    ButtonSwagTwitter: 'button-swag-twitter',
    ButtonSwagDiscord: 'button-swag-discord',
    ButtonSwagTelegram: 'button-swag-telegram',
    ButtonSwagTiktok: 'button-swag-tiktok',
    ButtonRta: 'button-rta',
    ButtonAsacp: 'button-asacp',
    ButtonDmca: 'button-dmca',
    ButtonSwagAffiliateProgram: 'button-swag-affiliate-program',
    ButtonMailToMarketing: 'button-mail-to-marketing',
    ButtonChangeEmail: 'button-change-email',
    ButtonChangePhoneNumber: 'button-change-phone-number',
    ButtonDisconnect: 'button-disconnect',
    ButtonUserToUserReferralBanner: 'button-user-to-user-referral-banner',
    ButtonHelpCenter: 'button-help-center',
    ButtonVipLevelCTA: 'vip-level-cta',
    ButtonVipLevelToggle: 'vip-level-toggle',
    ButtonVipLevelEdit: 'vip-level-edit',
    ButtonPushNotifications: 'button-push-notifications',
    ButtonPushSystemEnable: 'button-push-system-enable',
    ButtonPushSystemDisable: 'button-push-system-disable',
    ButtonPushDmEnable: 'button-push-dm-enable',
    ButtonPushDmDisable: 'button-push-dm-disable',
    ButtonPushFollowEnable: 'button-push-follow-enable',
    ButtonPushFollowDisable: 'button-push-follow-disable',
    ButtonPushUnknownEnable: 'button-push-unknown-enable',
    ButtonPushUnknownDisable: 'button-push-unknown-disable',
    ButtonEmailNotificationEnable: 'button-email-notification-enable',
    ButtonEmailNotificationDisable: 'button-email-notification-disable',
    ButtonVipExperienceNow: 'button-vip-experience-now',
    ButtonNextLevel: 'button-next-level',
    ButtonPreviousLevel: 'button-previous-level',
    ButtonVipBenefit: 'button-vip-benefit',
    ButtonVipTopUp: 'button-vip-top-up',
    ButtonVipTopUpUpgrade: 'button-vip-top-up-upgrade',
    ButtonVipTopUpMaintainLevel: 'button-vip-top-up-maintain-level',
    ButtonSharePicture: 'button-share-picture',
    ButtonBattlePass: 'button-battle-pass',
    ButtonOnlineSupport: 'button-online-support',
    ButtonRefresh: 'button-refresh',
  },
  DiamondShop: {
    ButtonRegisterNewCreditcard: 'topup-add-new-card-confirm',
    ButtonSwitchCurrency: 'button-switch-currency',
    ButtonServiceLineAt: 'button-service-line-at',
    ButtonServiceWhatsapp: 'button-service-whatsapp',
    ButtonServiceMessenger: 'button-service-messenger',
    ButtonPaymentCreditcard: 'button-payment-creditcard',
    ButtonPaymentMaster: 'button-payment-master',
    ButtonPaymentMarket: 'button-payment-market',
    ButtonPaymentGashPin: 'button-payment-gash-pin',
    ButtonPaymentGashWallet: 'button-payment-gash-wallet',
    ButtonPaymentWebcash: 'button-payment-webcash',
    ButtonPaymentUnionpay: 'button-payment-unionpay',
    ButtonPaymentAddCreditcard: 'button-payment-add-creditcard',
    ButtonPaymentAlipay: 'button-payment-alipay',
    ButtonPaymentVisa: 'button-payment-visa',
    ButtonPaymentGooglePay: 'button-payment-google-pay',
    ButtonPaymentApplePay: 'button-payment-apple-pay',
    ButtonPaymentPrepaidcard: 'button-payment-prepaidcard',
    ButtonPaymentJcb: 'button-payment-jcb',
    ButtonPaymentDiscover: 'button-payment-discover',
    ButtonPaymentAmericanExpress: 'button-payment-american-express',
    ButtonPaymentWechat: 'button-payment-wechat',
    ButtonPaymentLinepay: 'button-payment-linepay',
    ButtonPaymentAtm: 'button-payment-atm',
    ButtonPaymentWebAtm: 'button-payment-web-atm',
    ButtonPaymentDc: 'button-payment-dc',
    ButtonPay: 'button-pay',
    ButtonReceive: 'button-receive',
    ButtonPaymentMethodToggle: 'button-payment-method-toggle',
    ButtonPaymentMethodItem: 'button-payment-method-item',
    ButtonShopProduct: 'button-shop-product',
    ButtonOrderSummary: 'button-order-summary',
    ButtonPayWith: 'button-pay-with',
    ButtonContinuePay: 'button-continue-pay',
    ButtonAddNewCard: 'button-add-new-card',
    ButtonDeletePaymentMethod: 'button-delete-payment-method',
    ButtonShopAnchor: 'button-shop-anchor',
    ButtonProductDescription: 'button-product-description',
    ButtonShopProductLock: 'button-shop-product-lock',
    ButtonQuickpayQuestModeContinue: 'button-quickpay-guest-mode-continue',
    ButtonQuickpayLoginContinue: 'button-quickpay-login-continue',
  },
  LoginRegister: {
    ButtonToSetPassword: 'button-to-set-password',
    ButtonSwitchAccount: 'button-switch-account',
    ButtonContinueRegister: 'button-continue-register',
    ButtonBackToLogin: 'button-backtologin',
    ButtonForgotPassword: 'button-forgot-password',
    ButtonLoginPage: 'button-login-page',
    ButtonLoginApple: 'button-login-apple',
    ButtonLoginGoogle: 'button-login-google',
    ButtonLoginFacebook: 'button-login-facebook',
    ButtonLoginTwitter: 'button-login-twitter',
    ButtonLoginPhone: 'button-login-phone',
    ButtonLoginMail: 'button-login-mail',
    ButtonLoginDiscord: 'button-login-discord',
    ButtonLoginPassword: 'button-login-password',
    ButtonLoginWebAuthn: 'button-login-webauthn',
    ButtonLogin: 'button-login',
    ButtonGuestModeEnter: 'button-guest-mode-enter',
    ButtonEnableNow: 'button-enable-now',
    ButtonEnableLater: 'button-enable-later',
    ButtonSignup: 'button-signup',
    ButtonSignupApple: 'button-signup-apple',
    ButtonSignupGoogle: 'button-signup-google',
    ButtonSignupTwitter: 'button-signup-twitter',
    ButtonSignupPhone: 'button-signup-phone',
    ButtonSignupMail: 'button-signup-mail',
    ButtonSignupDiscord: 'button-signup-discord',
    ButtonSignupLogin: 'button-signup-login',
    ButtonRegister: 'button-register',
    ButtonVerifyLater: 'button-verify-later',
    ButtonChangeEmail: 'button-change-email',
    ButtonChangePhoneNumber: 'button-change-phone-number',
    ButtonOtherVerifyOptions: 'button-other-verify-options',
    ButtonVerifyPurchase: 'button-verify-purchase',
    ButtonVerifyCreditCard: 'button-verify-credit-card',
    ButtonVerifyTwid: 'button-verify-twid',
    ButtonTos: 'button-tos',
    ButtonResendPin: 'button-resend-pin',
    EmailDomainAutofix: 'email-domain-autofix',
    ButtonLoginOthers: 'button-login-others',
    ButtonRegisterOthers: 'button-register-others',
    ButtonWelcomeBackLogin: 'button-welcome-back-login',
    ButtonUseOtherLoginMethod: 'button-use-other-login-method',
    ButtonDoNotRemember: 'button-do-not-remember-me',
  },
  ForgetPassword: {
    SwitchToPhoneNumber: 'switch-to-phone-number',
    SwitchToEmail: 'switch-to-email',
  },
  BindAccount: {
    ButtonBindGoogle: 'button-bind-google',
    ButtonBindApple: 'button-bind-apple',
    ButtonBindWebAuthn: 'button-bind-webauthn',
  },
  EventPopup: {
    EventPopupLink: 'event-popup-link',
  },
  Toast: {
    BindMail: 'button-bind-mail',
    ButtonBindNow: 'button-bind-now',
    ButtonSkip: 'button-skip',
    ButtonSettingNow: 'button-setting-now',
  },
  Modal: {
    ButtonDownloadSchat: 'button-download-schat',
    ButtonGeneralRemoval: 'general-removal',
    ButtonNoReminderPayDirectly: 'button-no-reminder-pay-directly',
    ButtonConfirmExecute: 'button-confirm-execute',
    ButtonConfirmClose: 'button-confirm-close',
  },
  Chatroom: {
    ButtonAudioPlay: 'button-audio-play',
    ButtonAudioStop: 'button-audio-stop',
    ButtonCancelRecord: 'button-cancel-record',
    ButtonStopRecord: 'button-stop-record',
    ButtonFirstMessage: 'button-first-message',
    ButtonCpEvent: 'button-cp-event',
    ButtonJoinEvent: 'button-join-event',
    ChatAnnounce: 'chat-announce',
    ButtonChatFeed: 'button-chat-feed',
    ButtonChatroomSearchCancel: 'button-chatroom-search-cancel',
    ButtonTextTranslate: 'button-text-translate',
    ButtonTextCopy: 'button-text-copy',
    ButtonMediaLibrary: 'button-media-library',
    ButtonGoToProfile: 'button-go-to-profile',
    ButtonPinChat: 'button-pin-chat',
    ButtonUnpinChat: 'button-unpin-chat',
    ButtonCamera: 'button-camera',
    ButtonNewChatroom: 'button-new-chatroom',
    ButtonSearch: 'button-search',
  },
  LiveStream: {
    ButtonUserProfileLiveStream: 'button-user-profile-livestream',
    CountDownToDiamondShop: 'countdown-to-diamond-shop',
    ButtonTurnToPrivate: 'button-turn-to-private',
    ButtonGiftLeaderboard: 'button-gift-leaderboard',
    ButtonGiftLeaderboardTop10: 'button-gift-leaderboard-top10',
    ButtonLiveStreamChat: 'button-livestream-chat',
    ButtonCommandItem: 'button-command-item',
    ButtonLovenseCommandItem: 'button-lovense-command-item',
    ButtonCommandList: 'button-command-list',
    ButtonCommandPlaylistWaiting: 'button-command-playlist-waiting',
    ButtonCommandPlaylistExecuted: 'button-command-playlist-executed',
    ButtonLovenseCommandList: 'button-lovense-command-list',
    ButtonShowSummary: 'button-show-summary',
    ButtonShowPurchaseModal: 'button-show-purchase-modal',
    ButtonShowLastCallPopUp: 'button-show-last-call-popup',
    ButtonShowCompletePopUp: 'button-show-complete-popup',
    CommandHint: 'command-hint',
    ButtonGeneralLivestreamChatSelect: 'button-general-livestream-chat-select',
    ButtonNotifyLivestreamChatSelect: 'button-notify-livestream-chat-select',
    ButtonNotifyLivestreamChatSend: 'button-notify-livestream-chat-send',
    ButtonLivestreamChatSend: 'button-livestream-chat-send',
    ButtonPinSentence: 'button-pin-the-sentence',
    ButtonLowLatencyOn: 'button-low-latency-on',
    ButtonLowLatencyOff: 'button-low-latency-off',
    ButtonLivestreamFilter: 'button-livestream-filter',
    ButtonLivestreamSorting: 'button-livestream-sorting',
    ButtonLivestreamResetFilter: 'button-livestream-reset-filter',
    ButtonLivestreamAd1: 'button-livestream-ad-1',
    ButtonLivestreamAd2: 'button-livestream-ad-2',
    ButtonShowDetailSignup: 'button-show-detail-signup',
    ButtonPopupChatroom: 'button-popup-chatroom',
    ButtonReloadPlayer: 'button-reload-player',
    ButtonGiftSlotHistory: 'button-gift-slot-history',
    ButtonGiftSlotHelp: 'button-gift-slot-help',
    ButtonSicboHistory: 'button-sicbo-history',
    ButtonSicboHelp: 'button-sicbo-help',
    ButtonSoaringHigh: 'button-soaring-high',
    ButtonGoldenGate: 'button-golden-gate',
    ButtonSlotGame: 'button-slot-game',
    ButtonSicboGame: 'button-sicbo-game',
    ButtonDragonTigerFightGame: 'button-dragon-tiger-fight-game',
    ButtonGame: 'button-game',
    ButtonSicboBetBig: 'button-sicbo-bet-big',
    ButtonSicboBetSmall: 'button-sicbo-bet-small',
    ButtonSicboBetAnytriple: 'button-sicbo-bet-anytriple',
    ButtonOfflineToProfile: 'button-offline-to-profile',
    LivestreamChatItem: 'livestream-chat-item',
    ButtonLivestreamShowNotice: 'button-livestream-show-notice',
    ButtonUserTrigger: 'button-user-trigger',
    ButtonTriggerPrivate: 'button-trigger-private',
    ButtonTriggerExclusive: 'button-trigger-exclusive',
    ButtonWhatIsPrivateInvite: 'button-what-is-private-invite',
    ToggleExclusiveNotifyOn: 'toggle-exclusive-notify-on',
    ToggleExclusiveNotifyOff: 'toggle-exclusive-notify-off',
    ButtonEnterExclusivePrivate: 'button-enter-exclusive-private',
    ButtonSingleTicket: 'button-single-ticket',
    ButtonShowMore: 'button-show-more',
    ButtonShowMvp: 'button-show-mvp',
    ButtonRetryPlay: 'button-retry-play',
    ButtonSuperchat: 'button-superchat',
    ButtonCommandCapsuleToy: 'button-command-capsule-toy',
    ButtonExploreMoreLivestream: 'button-explore-more-livestream',
    ButtonExploreMoreLivestreamFollowing:
      'button-explore-more-livestream-following',
    ButtonExploreMoreLivestreamPopular:
      'button-explore-more-livestream-popular',
    ButtonExploreMoreLivestreamClose: 'button-explore-more-livestream-close',
    ButtonFocusMode: 'button-focus-mode',
    ButtonHotkey: 'button-hotkey',
    ButtonGiftSendLog: 'button-gift-send-log',
  },
  Detail: {
    PlayerControlsFullscreen: 'player-controls-fullscreen',
    PlayerControlsPlay: 'player-controls-play',
    PlayerControlsPause: 'player-controls-pause',
    PlayerControlsSeekbar: 'player-controls-seekbar',
    ButtonWatchFullVideo: 'button-watch-full-video',
    ButtonWatchFullVideoFinished: 'button-watch-full-video-finished',
    ButtonRelatedVideo: 'button-related-video',
    ButtonInfo: 'button-info',
    ButtonRecommendFlix: 'button-recommend-flix',
    ButtonRecommendFlixAvatar: 'button-recommend-flix-avatar',
    ButtonAgeVerifyFlixDetail: 'button-age-verify-flix-detail',
    ButtonFreeDetailSignup: 'button-free-detail-signup',
    ButtonDetailSignup: 'button-detail-signup',
    ButtonSingleUnlocked: 'button-single-unlocked',
    ButtonGoToMessagePack: 'button-go-to-message-pack',
    ContentDetailName: 'content-detail-name',
  },
  Event: {
    ItemLotteryEvent: 'item-lottery-event',
    ButtonAskForDetails: 'button-ask-for-details',
    ButtonCpEventChat: 'button-cp-event-chat',
  },
  Freezone: {
    ButtonPublish: 'button-publish',
    ButtonUploadVideoIcon: 'button-upload-video-icon',
    TabPro: 'tab-pro',
    TabAmateur: 'tab-amateur',
  },
  Topup: {
    ButtonTopupTurnOffCancel: 'topup-turn-off-cancel',
    ButtonTopupPaymentMethodRemove: 'topup-removal',
  },
  Leaderboard: {
    ButtonLeaderboardUser: 'button-leaderboard-user',
    ButtonLeaderboardTab: 'button-leaderboard-tab',
  },
  Notification: {
    NotificationItem: 'notification-item',
    ButtonNotificationLivestream: 'button-notification-livestream',
  },
  Verification: {
    ButtonBindCreditCard: 'button-bind-credit-card',
    ButtonCustomerServiceVerify: 'button-customer-service-verify',
    ButtonFirstPurchase: 'button-first-purchase',
    ButtonUserAgeVerify: 'button-user-age-verify',
    ButtonPhoneVerify: 'button-phone-verify',
    ButtonDiamondShop: 'button-diamond-shop',
  },
  Join: {
    ButtonBecomeCreator: 'button-become-creator',
    ButtonTakePhoto: 'button-take-photo',
    ButtonCapture: 'button-capture',
    ButtonVerifyNow: 'button-verify-now',
    ButtonDownloadApp: 'button-download-app',
  },
  Backpack: {
    ButtonBackpack: 'button-backpack',
    ButtonTicketRedeem: 'button-ticket-redeem',
    ButtonReceive: 'button-receive',
    ButtonMission: 'button-mission',
    TabTicket: 'tab-ticket',
  },
  Subscription: {
    ButtonSubscribe: 'button-subscribe',
    ButtonUnlockPost: 'button-unlock-post',
  },
  Post: {
    ButtonPostCommentCount: 'button-post-comment-count',
    ButtonPostComment: 'button-post-comment',
    ButtonPostLikeCount: 'button-post-like-count',
    ButtonPostCommentViewMore: 'button-post-comment-view-more',
    ButtonSummary: 'button-summary',
    ButtonPostMedia: 'button-post-media',
    ButtonPostVideoReplay: 'Button-post-video-replay',
    ButtonPostTextMore: 'button-post-text-more',
  },
  Upload: {
    ButtonUpload: 'button-upload',
    ButtonCancelUpload: 'button-cancel-upload',
    ButtonCameraLivestream: 'button-camera-livestream',
    ButtonStory: 'button-story',
    ButtonPost: 'button-post',
    ButtonPublish: 'button-publish',
    ButtonPreview: 'button-preview',
    ButtonPostPhotos: 'button-post-photos',
    ButtonPostVideo: 'button-post-video',
    ButtonUploadFailedTryAgain: 'button-upload-failed-try-again',
    ButtonFansId: 'button-fans-id',
    SchedulePostToggleOn: 'schedule-post-toggle-on',
    SchedulePostToggleOff: 'schedule-post-toggle-off',
    ExpiringToggleOn: 'expiring-toggle-on',
    ExpiringToggleOff: 'expiring-toggle-off',
  },
  BankAccount: {
    ButtonEditPaymentMethod: 'button-edit-payment-method',
    ButtonSave: 'button-save',
  },
  Profile: {
    ButtonProfileHome: 'button-profile-home',
    ButtonEditProfileDone: 'button-edit-profile-done',
    ButtonEditProfileChangePhoto: 'button-edit-profile-change-photo',
    ButtonManageProfile: 'button-manage-profile',
    ButtonManageWebAuthn: 'button-manage-webauthn',
    ButtonLinkWebAuthn: 'button-link-webauthn',
    ButtonProfilePost: 'button-profile-post',
    ButtonProfileVideo: 'button-profile-video',
    ButtonProfileImage: 'button-profile-image',
    ButtonProfileStory: 'button-profile-story',
    ButtonProfileLive: 'button-profile-live',
    ButtonProfileShorts: 'button-profile-shorts',
    ButtonPostClick: 'post-click',
    ButtonCreatePost: 'button-create-post',
    ButtonCreateVideo: 'button-create-video',
    ButtonCreateImage: 'button-create-image',
    ButtonCreateStory: 'button-create-story',
    ButtonCreateLive: 'button-create-live',
    ButtonManage: 'button-manage',
    ButtonAccount: 'button-account',
    ButtonKycBadge: 'button-kyc-badge',
    ButtonChatPrice: 'button-chat-price',
    ButtonSubscriptionPrice: 'button-subscription-price',
    ButtonUsername: 'button-username',
    ButtonDisplayName: 'button-display-name',
    ButtonBiography: 'button-biography',
    ButtonFollowers: 'button-followers',
    ButtonFollowing: 'button-following',
    ButtonAdvancedManagement: 'button-advanced-management',
    ButtonSubscribers: 'button-subscribers',
    ButtonSubscribed: 'button-subscribed',
    ButtonAccountLink: 'button-account-link',
    ButtonPasswordSetting: 'button-password-setting',
    ButtonBlockList: 'button-block-list',
    ButtonPaymentMethodList: 'button-payment-method-list',
    ButtonReceiptSetting: 'button-receipt-setting',
    ButtonTotalEarnings: 'button-total-earnings',
    ButtonSubscriptionEarnings: 'button-subscription-earnings',
    ButtonContest: 'button-contest',
    ButtonSubscriberDetail: 'button-subscriber-detail',
    ButtonSubscribedDetail: 'button-subscribed-detail',
    ButtonContract: 'button-contract',
    ButtonRelevantDocuments: 'button-relevant-documents',
    ButtonWithdrawMethod: 'button-withdraw-method',
    ButtonWatchLivestream: 'button-watch-livestream',
    ButtonWatchStory: 'button-watch-story',
    ButtonWatchAvatar: 'button-watch-avatar',
    ButtonProfileSorting: 'button-profile-sorting',
    ButtonUnpublishedCard: 'button-unpublished-card',
    ButtonDeactivate: 'button-deactivate',
  },
  Hashtag: {
    ButtonHashtagSorting: 'button-hashtag-sorting',
    ButtonUserHashtag: 'button-user-hashtag',
  },
  Category: {
    Add: 'add-category',
    Save: 'save-category',
    TabAll: 'button-category-all',
    TabStory: 'button-category-story',
    TabFlix: 'button-category-video',
    TabShort: 'button-category-short',
    TabImage: 'button-category-image',
    Sorting: 'button-category-sorting',
  },
  Shorts: {
    ShortsCaptionOpen: 'shorts-caption-open',
    ShortsCaptionClose: 'shorts-caption-close',
    ButtonShortsToLivestream: 'button-shorts-to-livestream',
    ButtonVisitorShortsToLivestream: 'button-visitor-shorts-to-livestream',
    ButtonShortAdsClick: 'button-short-ads-click',
  },
  Referral: {
    CurrentMonth: 'current-month',
    PastTwelveMonth: 'past-twelve-month',
    PastCancel: 'past-cancel',
  },
  Browse: {
    ButtonGoExplore: 'button-go-explore',
  },
  Pagination: {
    PagePrevious: 'button-page-previous',
    PageNext: 'button-page-next',
    Page: 'button-page',
  },
  MissionCenter: {
    ButtonMissionAnchor: 'button-mission-anchor',
  },
  ReceiptSetting: {
    ButtonEReceipt: 'button-e-receipt',
  },
};

export const ElementId = {
  Chatroom: {
    ButtonGiftCategory: 'button-gift-category',
    GiftSlider: 'gift-slider',
  },
  DiamondShop: {
    CurrencyItem: 'currency-item',
  },
  Join: {
    ButtonBecomeCreatorCountry: 'button-become-creator-country',
    InputBecomeCreatorUsername: 'input-become-creator-username',
    InputBecomeCreatorReferralCode: 'input-become-creator-referral-code',
    InputBecomeCreatorPassword: 'input-become-creator-password',
    InputBecomeCreatorEmail: 'input-become-creator-email',
    SelectBecomeCreatorGender: 'select-become-creator-gender',
  },
  ManageProfile: 'manage-profile',
  ManageProfileAccount: {
    AccountLinks: 'account-links',
    BlockedList: 'blocked-list',
    CardInfo: 'card-info',
    DeleteAccount: 'delete-account',
    EReceipt: 'e-receipt',
    MyEReceipt: 'my-e-receipt',
  },
};

export const ModalId = {
  Feed: {
    FilterDetail: 'filter-detail',
  },
  Landing: {
    Over18BirthdayModal: 'over-18-birthday-modal',
    LandingPage2024Iwin: 'landing-page-2024-iwin',
    ModalOver18: 'modal-over-18',
  },
  Guest: {
    ModalChooseEntryOption: 'modal-choose-entry-option',
  },
  LoginSignup: {
    LoginEntries: 'login-entries',
    LoginEntriesCn: 'login-entries-cn',
    SignupEntries: 'signup-entries',
    SignupEntriesCn: 'signup-entries-cn',
    UsernamePasswordEnter: 'username-password-enter',
    EmailEnter: 'email-enter',
    EmailVerify: 'email-verify',
    PhoneEnter: 'phone-enter',
    PhoneReward: 'phone-reward',
    PhoneCountryCodes: 'phone-country-codes',
    PhoneVerify: 'phone-verify',
    EmailRefill: 'email-refill',
    QRCode: 'qr-code',
    SwitchAccount: 'switch-account',
    BindEmailChangeBrowserRelogin: 'bind-email-change-browser-relogin',
    ForgotPassword: 'forgot-password',
    AgeVerificationPopup: 'age-verification-popup',
    VerifyAgeUnlockClearPreview: 'modal-verify-age-unlock-clear-preview',
    PasskeySetUpReminder: 'modal-passkey-set-up-reminder',
    WelcomeBack: 'modal-welcome-back',
  },
  WebAuthn: {
    LoginError: 'modal-webauthn-login-error',
    DuplicatedError: 'modal-webauthn-duplicated-error',
  },
  Register: {
    RegisterPage: 'register-page',
    RegisterPageTw: 'register-page-tw',
    AgeEnterTw: 'age-enter-tw',
  },
  Bind: {
    BindEmailEnter: 'bind-email-enter',
    BindEmailVerify: 'bind-email-verify',
    BindEmailFailed: 'bind-email-failed',
    BindEmailRelogin: 'bind-email-relogin',
    ModalBindEmailHint: 'modal-bind-email-hint',
    ModalNotYetVerified: 'modal-not-yet-verified',
    ModalBindSuccess: 'modal-bind-success',
    BindPhoneVerify: 'bind-phone-verify',
    ModalBindAccount: 'modal-bind-account-entries',
    ToasterModalBindAccount: 'modal-bind-account',
  },
  AppleMigration: {
    ModalAppleRebind: 'modal-apple-rebind',
    ModalRebindSuccess: 'modal-rebind-success',
    ModalRebindErrorFirstTime: 'modal-rebind-error-first-time',
    ModalRebindErrorSecondTime: 'modal-rebind-error-second-time',
    ModalAppleRebindNotice: 'modal-apple-rebind-notice',
  },
  DiamondShop: {
    DiamondShopDiamondPacks: 'diamond-shop-diamond-packs',
    DiamondShopSelectPaymentMethod: 'diamond-shop-select-payment-method',
    DiamondShopSelectCurrency: 'diamond-shop-select-currency',
    DiamondShopOrderUnderProcessing: 'diamond-shop-order-under-processing',
    DiamondShopOrderProcessing: 'diamond-shop-order-processing',
    DiamondShopOrderComplete: 'diamond-shop-order-complete',
    DiamondShopOrderFailed: 'diamond-shop-order-failed',
    DiamondShopOrderProcessingInapp: 'diamond-shop-order-processing-inapp',
    DiamondShopOrderCompleteInapp: 'diamond-shop-order-complete-inapp',
    DiamondShopOrderFailedInapp: 'diamond-shop-order-failed-inapp',
    DiamondShopCreditcardEnter: 'diamond-shop-creditcard-enter',
    SubtotalPayment: 'subtotal-payment',
    ModalProductNotice: 'modal-product-notice',
    ModalQuickpay: 'modal-quickpay',
    ModalConfirmLeave: 'modal-confirm-leave',
    ModalQuickpayChooseOptionContinue: 'modal-quickpay-choose-option-continue',
  },
  Popup: {
    IosUnsupportedDownloadSchat: 'ios-unsupported-download-schat',
    IosDownloadSchat: 'ios-download-schat',
    AddToHomeScreen: 'add-to-home-screen',
    AndroidNotificationOpenFirst: 'android-notification-open-first',
    AndroidNotificationOpenTutorial: 'android-notification-open-tutorial',
    AgeVerification: 'age-verification',
    MyProfileEdit: 'my-profile-edit',
    EventPopup: 'event-popup',
    NotRegisterPopup: 'not-register-popup',
    NotUserPopup: 'not-user-popup',
    UnconfirmedRegisterPopup: 'unconfirmed-register-popup',
    BindMail: 'toast-bind-mail',
    GeneralRemovePopup: 'general-removal-modal',
    DrmCannotPlayPopup: 'drm-cannot-play-popup',
    AgeVerificationPopup: 'age-verification-popup',
    CardVerify: 'card-verify',
    ModalProfileMore: 'modal-profile-more',
    ModalSubscriberDetail: 'modal-subscriber-detail',
    ModalSubscribedDetail: 'modal-subscribed-detail',
    ModalMessageMore: 'modal-message-more',
    FilterPopup: 'filter-popup',
    SortingPopup: 'sorting-popup',
    UnpinReplace: 'unpin-replace',
    ModalUnpin: 'modal-unpin',
    ModalClip: 'modal-clip',
    ModalInsufficientClipDuration: 'modal-insufficient-clip-duration',
    ModalVideoLessThan60s: 'modal-video-less-than-60s',
    ModalIntercomArticle: 'modal-intercom-article',
    ModalIframeArticle: 'modal-iframe-article',
    ModalDiscard: 'modal-discard',
    ModalMessagePackUpsell: 'modal-message-pack-upsell',
    UpdateDisplayNameFailed: 'update-display-name-failed',
    ModalMicrophoneUnsupported: 'modal-microphone-unsupported',
    ModalEventDragonTigerFightGame: 'modal-event-dragon-tiger-fight-game',
    ModalEventSoaringHighGame: 'modal-event-soaring-high-game',
    ModalEventSicBoGame: 'modal-event-sic-bo-game',
    ModalEventGoldenGateGame: 'modal-event-golden-gate-game',
    ModalExploreGameMenu: 'modal-explore-game-menu',
    ModalExploreCampaign: 'modal-explore-campaign',
  },
  Prepaid: {
    PrepaidRedemption: 'prepaid-redemption',
    PrepaidConfirmPopup: 'prepaid-confirm-popup',
    PrepaidSuccessPopup: 'prepaid-success-popup',
  },
  LiveStream: {
    ToPrivateCountDownPopUp: 'to-private-countdown-popup',
    LastCallCountDownPopUp: 'last-call-countdown-popup',
    LivestreamCommandPlaylist: 'livestream-command-playlist',
    LivestreamCommandPlaylistWaiting: 'livestream-command-playlist-waiting',
    LivestreamCommandPlaylistExecuted: 'livestream-command-playlist-executed',
    LivestreamLovenseCommandPlaylist: 'livestream-lovense-command-playlist',
    LivestreamShowPurchaseModalPerforming:
      'livestream-show-purchase-modal-performing',
    LivestreamShowPurchaseModal: 'livestream-show-purchase-modal',
    LivestreamShowLastCallPopUp: 'livestream-show-last-call-popup',
    LivestreamShowCompletePopUp: 'livestream-show-complete-popup',
    CommandHint: 'command-hint',
    LivestreamFreeLimitChat: 'livestream-free-limit-chat',
    ModalLivestreamMore: 'modal-livestream-more',
    ModalLivestreamGameMenu: 'modal-livestream-game-menu',
    ModalLivestreamGift: 'modal-livestream-gift',
    ModalLivestreamUserTrigger: 'modal-livestream-user-trigger',
    GiftSlot: 'gift-slot',
    GiftSlotHelp: 'gift-slot-help',
    GiftSlotHistory: 'gift-slot-history',
    SicBoGame: 'sic-bo-game',
    DragonTigerFight: 'dragon-tiger-fight',
    SoaringHigh: 'soaring-high',
    GoldenGate: 'golden-gate',
    SicBoDrawResult: 'sic-bo-draw-result',
    SicBoBetWinToaster: 'sic-bo-bet-win-toaster',
    SicBoBetSummary: 'sic-bo-bet-summary',
    SicBoHelp: 'sic-bo-help',
    SicBoHistory: 'sic-bo-history',
    SicBoTutorial: 'sic-bo-tutorial',
    LivestreamLowLatencyWaitingHint: 'livestream-low-latency-waiting-hint',
    LivestreamMiniProfile: 'livestream-mini-profile',
    MiniProfileBadgeDetail: 'mini-profile-badge-detail',
    LivestreamShowNotice: 'livestream-show-notice',
    PrivateLivestreamDetail: 'private-livestream-detail',
    LivestreamBannedNotification: 'livestream-banned-notification',
    ModalTriggerPrivateSucceeded: 'modal-trigger-private-succeeded',
    ModalTriggerPrivateFailed: 'modal-trigger-private-failed',
    ModalTriggerPrivateLeavingAlert: 'modal-trigger-private-leaving-alert',
    ModalUserTrigger: 'modal-user-trigger',
    ModalUserTriggerHelp: 'modal-user-trigger-help',
    ModalTriggerExclusiveSucceeded: 'modal-trigger-exclusive-succeeded',
    ModalTriggerExclusiveFailed: 'modal-trigger-exclusive-failed',
    ModalTurnToExclusivePrivate: 'modal-turn-to-exclusive-private',
    ModalExclusivePrivatePurchaseDiamond:
      'modal-exclusive-private-purchase-diamond',
    ModalEnterExclusivePrivate: 'modal-enter-exclusive-private',
    ModalLivestreamAlert: 'modal-livestream-alert',
    ModalLivestreamTimeNotSync: 'modal-livestream-time-not-sync',
    SuperchatSendConfirm: 'superchat-send-confirm',
    ModalGiftSendPopup: 'modal-gift-send-popup',
    ModalGiftAnimationDownloadFail: 'modal-gift-animation-download-fail',
    ModalPreviewGiftAnimation: 'modal-preview-gift-animation',
    ModalExploreMoreLivestream: 'modal-explore-more-livestream',
    ModalGiftSendConfirm: 'modal-gift-send-confirm',
    ModalCommandConfirm: 'modal-command-confirm',
  },
  Chatroom: {
    CpEventPage: 'cp-event-page',
    ModalTextMore: 'modal-text-more',
  },
  Settings: {
    PaymentMethodSelector: 'settings-payment-method',
    ResetPassword: 'reset-password',
    ChannelVip: 'settings-channel-vip',
    Logout: 'modal-logout',
    ModalLanguageMenu: 'modal-language-menu',
    DisconnectSocialAccount: 'settings-disconnect-social-account',
    ModalVipBenefit: 'modal-vip-benefit',
  },
  HamburgerMenu: {
    Menu: 'modal-hamburger',
  },
  Notification: {
    AgeVerification: 'age-verificaiton-banner',
    NotificationCenterList: 'notification-center-list',
  },
  Topup: {
    TopupTurnOffPopup: 'topup-turnoff-modal',
    TopupPaymentMethodRemoveConfirm: 'topup-remove-creditcard-modal',
  },
  Join: {
    ModalBecomeCreator: 'modal-become-creator',
    ModalPhotoRequirement: 'modal-photo-requirement',
    ModalMaleReject: 'modal-male-reject',
    ModalVerificationNotComplete: 'modal-verification-not-complete',
    ModalDownloadApp: 'modal-download-app',
    PhotoOfYourId: 'photo-of-your-id',
    PhotoOfYourself: 'photo-of-yourself',
    CheckImageQuality: 'check-image-quality',
  },
  Backpack: {
    ModalBackpack: 'modal-backpack',
    ModalBackpackItemDetail: 'modal-ticket',
  },
  Subscription: {
    ModalSubscribe: 'modal-subscribe',
    ModalUnlockPost: 'modal-unlock-post',
  },
  Post: {
    ModalPostLikeDetail: 'modal-post-like-detail',
    ModalPostSummaryDetail: 'modal-post-summary-detail',
    ModalHiddenRequest: 'modal-hidden-request',
    ModalHiddenInfo: 'modal-hidden-info',
    ModalPublishAlert: 'modal-publish-alert',
  },
  Upload: {
    ModalCreate: 'modal-create',
    CreateEditPost: 'create-edit-post',
    CreateEditStory: 'create-edit-story',
    ModalMessageCategory: 'modal-message-category',
    ModalEditBack: 'modal-edit-back',
    ModalPost: 'modal-post',
    ModalPreview: 'modal-preview',
    ModalUploadMore: 'modal-upload-more',
  },
  BankAccount: {
    UnsavedChanges: 'unsaved-changes',
  },
  Profile: {
    ChatPrice: 'chat-price',
    SubscriptionPrice: 'subscription-price',
    ModalAdvancedManagement: 'modal-advanced-management',
    RelevantDocuments: 'relevant-documents',
    Contract: 'contract',
    ModalClickAvatar: 'modal-click-avatar',
    ModalResubscribeHint: 'modal-resubscribe-hint',
    MyProfileLivestreamSessionLeaderboard:
      'my-profile-livestream-session-leaderboard',
    UsernameNotSaved: 'modal-unsaved-changes',
    DisplayNameNotSaved: 'unsaved-changes',
    ActivateWebAuthn: 'modal-activate-webauthn',
    DeactivateWebAuthn: 'modal-deactivate-webauthn',
  },
  Referral: {
    ReferralBonusDuration: 'referral-bonus-duration',
  },
  All: {
    RatingModal: 'rating-modal',
    ModalRatingButton: 'modal-rating-button',
    ModalMissionCenter: 'modal-user-mission',
  },
  ReceiptSetting: {
    ModalReceiptSetting: 'modal-receipt-setting',
    ModalMobileCarrierBilling: 'modal-mobile-carrier-billing',
    ModalSwagCarrierBilling: 'modal-swag-carrier-billing',
  },
  Alert: {
    ModalUserBanned: 'modal-user-banned',
  },
};

export const InputId = {
  Email: 'input.email',
  EmailPin: 'input.email.pin',
  Phone: 'input.phone',
  PhonePin: 'input.phone.pin',
  EmailOrPhone: 'input.email_or_phone',
  UsernameOrEmail: 'input.username_or_email',
  Password: 'input-password',
};

/**
 * @typedef {Object} EventTypes - map event name to mixpanel
 * @property {string} PLAYER_VISIBLE
 * @property {string} PLAYER_HIDDEN
 * @property {string} PLAYER_STARTED
 * @property {string} PLAYER_STOPPED
 * @property {string} USER_CLICKED
 * @property {string} VIEW_OPENED
 * @property {string} VIEW_CLOSED
 * @property {string} HAPPYHOUR_NAVBAR_CLICKED
 * @property {string} HAPPYHOUR_CONTENT_PAGE_GREEN_BANNER_CLICKED
 * @property {string} HAPPYHOUR_CONTENT_PAGE_RED_BANNER_CLICKED
 * @property {string} HAPPYHOUR_CONTENT_PAGE_LOGO_CLICKED
 * @property {string} HAPPYHOUR_OVERLAY_INFO_CLICKED
 * @property {string} HAPPYHOUR_OVERLAY_SHAREBUTTON
 * @property {string} HAPPYHOUR_PAGE_OPENED
 * @property {string} SEARCH_STARTED
 * @property {string} SEARCH_ENDED
 * @property {string} FEED_FILTER_APPLIED
 */

export const EventTypes = {
  PLAYER_VISIBLE: 'player.visible',
  PLAYER_HIDDEN: 'player.hidden',
  PLAYER_STARTED: 'player.started',
  PLAYER_STOPPED: 'player.stopped',
  USER_CLICKED: 'v2.user.clicked',
  VIEW_OPENED: 'v2.view.opened',
  VIEW_CLOSED: 'v2.view.closed',
  HAPPYHOUR_NAVBAR_CLICKED: 'happyhour.navbar.clicked',
  HAPPYHOUR_CONTENT_PAGE_GREEN_BANNER_CLICKED:
    'happyhour.content.page.green.banner.clicked',
  HAPPYHOUR_CONTENT_PAGE_RED_BANNER_CLICKED:
    'happyhour.content.page.red.banner.clicked',
  HAPPYHOUR_CONTENT_PAGE_LOGO_CLICKED: 'happyhour.content.page.logo.clicked',
  HAPPYHOUR_OVERLAY_INFO_CLICKED: 'happyhour.overlay.info.clicked',
  HAPPYHOUR_OVERLAY_SHAREBUTTON: 'happyhour.overlay.sharebutton',
  HAPPYHOUR_PAGE_OPENED: 'happyhour.page.opened',
  NOTIFICATION_DISPLAYED: 'notification.displayed',
  NOTIFICATION_CLICKED: 'notification.clicked',
  PUSH_NOTIFICATION_RECEIVED: 'push.notification.received',
  PUSH_NOTIFICATION_CLICKED: 'push.notification.clicked',
  USER_FLIX_NO_SEEK: 'user.flix-no-seek',
  USER_FLIX_REGULAR_SEEK: 'user.flix-regular-seek',
  USER_SESSION_TICK: 'user.session-tick',
  USER_WATERMARK_STYLE_CHANGED: 'user.watermark-style-changed',
  USER_WATERMARK_VALIDATE: 'user.watermark-validate',
  USER_WATERMARK_INTERSECION_VALIDATE: 'user.watermark-intersection-validate',
  USER_VIDEO_LOCATION_CHANGED: 'user.video-location-changed',
  USER_VIDEO_SET_CONTROLS: 'user.video-set-controls',
  USER_VIDEO_ENTER_PIP: 'user.video-enter-pip',
  USER_NON_PLAYER_ENTER_FULLSCREEN: 'user.non-player-enter-fullscreen',
  USER_FLIX_DISTURBED: 'user.flix-disturbed',
  REVENUE_KEEPER: 'user.trigger-revenue-keeper',
  USER_FLIX_GOT_HELP: 'user.flix-got-help',
  USER_TRY_OVERRIDE_WINDOW_FUNCTION: 'user.try-override-window-function',
  USER_FLIX_TRY_MODIFY_Z_INDEX: 'user.flix-try-modify-z-index',
  USER_FLIX_SEEK_BEHAVIOR: 'user.flix-seek-behavior',
  USER_BACKGROUND_ENHANCED: 'user.background-enhanced',
  LIVESTREAM_PAYMENT: 'livestream.payment',
  LIVESTREAM_PAYMENT_CANCELED: 'livestream.payment.canceled',
  LIVESTREAM_TOKEN_GOT: 'livestream.token-got',
  LIVESTREAM_STREAM_AUTHORIZED: 'livestream.stream-authorized',
  LIVESTREAM_CHANGE_PRESET: 'livestream.change-preset',
  LIVESTREAM_PLAYER_FALLBACK: 'player.fallback',
  LIVESTREAM_PLAYER_BUFFER_STALLED: 'player.buffer-stalled',
  LIVESTREAM_PLAYER_AUTOPLAY_FAILED: 'player.autoplay-failed',
  LIVESTREAM_PLAYER_WAITING: 'player.waiting',
  PLAYER_ERROR: 'player.error',
  AUDIO_PLAYER_ERROR: 'audio-player.error',
  PUSHER_EVENT_GOT: 'pusher.event-got',
  PUSHER_CHANNEL_STALLED: 'pusher.channel-stalled',
  USER_DEBUG_SENT: 'user.debug.sent',
  USER_LOGGED_IN: 'user.logged_in',
  MESSAGE_CREATE_FAILED: 'message.create.failed',
  MESSAGE_UPDATE_FAILED: 'message.update.failed',
  SEARCH_STARTED: 'search.started',
  SEARCH_ENDED: 'search.ended',
  ORDER_CREATION_SUCCESS: 'order.creation.success',
  ORDER_CREATION_FAILED: 'order.creation.failed',
  USER_WEB_VITALS_METRIC_SENT: 'user.web-vitals-metric.sent',
  USER_DEBUG_FEED_CONTENT_ERROR: 'user.debug.feed-content-error',
  USER_DEBUG_NETWORKING_REQUEST: 'user.debug.networking-request',
  USER_DEBUG_VERSION_CHANGED: 'user.debug.version-changed',
  USER_DEBUG_FCM_TOKEN: 'user.debug.fcm-token',
  USER_DEBUG_MESSAGE_PRICE: 'user.debug.message-price',
  USER_DEBUG_PLAYER_ERROR: 'user.debug.player-error',
  USER_TOKEN_GOT: 'user.token-got',
  LIVESTREAM_FETCH_TOKEN_START: 'livestream.fetch-token-start',
  LIVESTREAM_FETCH_TOKEN_ERROR: 'livestream.fetch-token-error',
  LIVESTREAM_PAYMENT_ERROR: 'livestream.payment.error',
  LIVESTREAM_EXCLUSIVE_STATUS_CHANGE: 'livestream.exclusive.status.change',
  LIVESTREAM_EXCLUSIVE_PREPARING_TIMER: 'livestream.exclusive.preparing-timer',
  FEED_FILTER_APPLIED: 'feed.filter-applied',
  MEDIA_ENGAGEMENT: 'media.engagement',
  PLAYER_FREEZE_LOG: 'player.freeze-log',
  LIVESTREAM_GIFT_ANIMATION_PLAYED: 'livestream.gift-animation.played',
};

export const VIEW_PATH_MAP = {
  '/': 'home-explore',
  '/video': 'home-video',
  '/story': 'home-story',
  '/livestream': 'home-livestream',
  '/shorts/:messageId': 'shorts-detail',
  [`/shorts/:messageId/${ProfileListPublishStatus.DRAFT}`]:
    'unpublished-shorts-detail',
  '/category-overview': 'category-overview',
  '/category/:category': 'category-all',
  '/category/:category/story': 'category-story',
  '/category/:category/flix': 'category-post-video',
  '/category/:category/short': 'category-short',
  '/category/:category/image': 'category-image',
  '/flix-categories/:category': 'flix-categories',
  '/story-categories/:category': 'story-categories',
  '/shorts-categories/:category': 'shorts-categories',
  '/user-categories/:category': 'user-categories',
  '/user-feed-grid/:category': 'user-feed-grid',
  '/user-leaderboard-grid/:category': 'user-leaderboard-grid',
  '/user-following-grid/:category': 'user-feed-grid',
  '/leaderboard/:region/all/:range': 'leaderboard-all',
  '/leaderboard/:region/broadcast/:range': 'leaderboard-unlock',
  '/leaderboard/:region/chat/:range': 'leaderboard-chat',
  '/leaderboard/:region/gift/:range': 'leaderboard-gift',
  '/leaderboard/:region/livestream/:range': 'leaderboard-livestream',
  '/leaderboard/:region/new/:range': 'leaderboard-new',
  '/search/all': 'search-all',
  '/search/flix': 'search-flix',
  '/search/swagger/online': 'search-creator-online',
  '/search/swagger/new': 'search-creator-new',
  '/search/story': 'search-story',
  '/search/hashtag': 'search-hashtag',
  '/hashtag/:query': 'hashtag',
  '/hashtag/:query/flix': 'hashtag-flix',
  '/hashtag/:query/story': 'hashtag-story',
  '/chat/:chatroomId/message/:messageId': 'message-detail',
  '/message/:messageId': 'message-detail',
  '/story/:messageId': 'message-detail',
  '/story-preview/:messageId': 'message-detail',
  '/flix/:messageId': 'flix-detail',
  '/user/:userId': 'user-profile',
  '/user/:userId/home': 'user-profile-home',
  '/user/:userId/image': 'user-profile-image',
  '/user/:userId/story': 'user-profile-story',
  '/user/:userId/flix': 'user-profile-flix',
  '/user/:userId/livestreamSession': 'user-profile-livestream-session',
  '/user/:userId/short': 'user-profile-shorts',
  [`/user/:userId/image/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-image-unpublished',
  [`/user/:userId/story/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-story-unpublished',
  [`/user/:userId/flix/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-flix-unpublished',
  [`/user/:userId/livestreamSession/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-livestream-session-unpublished',
  [`/user/:userId/short/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-shorts-unpublished',
  [`/user/:userId/all/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-all-unpublished',
  [`/user/:userId/${LIVESTREAM_PATH}`]: 'livestream-detail',
  '/user/:userId/chat': 'chatroom-fake',
  '/u/:username': 'user-profile',
  '/u/:username/home': 'user-profile-home',
  '/u/:username/image': 'user-profile-image',
  '/u/:username/story': 'user-profile-story',
  '/u/:username/flix': 'user-profile-flix',
  '/u/:username/livestreamSession': 'user-profile-livestream-session',
  '/u/:username/short': 'user-profile-shorts',
  [`/u/:username/image/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-image-unpublished',
  [`/u/:username/story/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-story-unpublished',
  [`/u/:username/flix/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-flix-unpublished',
  [`/u/:username/livestreamSession/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-livestream-session-unpublished',
  [`/u/:username/short/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-shorts-unpublished',
  [`/u/:username/all/${ProfileListPublishStatus.DRAFT}`]:
    'user-profile-all-unpublished',
  [`/u/:username/${LIVESTREAM_PATH}`]: 'livestream-detail',
  '/u/:username/chat': 'chatroom-fake',
  '/messagePack/list': 'my-profile-archive-messagepack-collection',
  '/product/:productId': 'product-detail',
  '/archive/userId/:id/story': 'my-profile-archive-cp-story',
  '/archive/userId/:id/flix': 'my-profile-archive-cp-flix',
  '/archive/userId/:id/chat': 'my-profile-archive-cp-chatroom',
  '/me/edit': 'my-profile-edit-page',
  '/profile/following': 'my-profile-following-list',
  '/profile/follower': 'my-profile-follower-list',
  '/profile/subscribed': 'subscribed',
  '/profile/subscriber': 'subscriber',
  '/settings': 'settings',
  '/settings/notification': 'settings-notification',
  '/settings/more': 'settings-more',
  '/settings/more/debug': 'settings-debug',
  '/settings/more/drm': 'settings-drm',
  '/settings/more/about': 'settings-about',
  '/settings/more/delete-account': 'settings-delete-account',
  '/settings/vvip': 'settings-channel-vip',
  '/settings/auto-addvalue': 'settings-auto-addvalue',
  '/settings/2257': 'settings-2257',
  '/settings/journal': 'journal',
  '/settings/referral': 'settings-referral',
  '/settings/referral/result': 'referral-result',
  '/settings/redeem': 'settings-redeem',
  '/settings/bank-account': 'payment-method',
  '/chat': 'chatlist',
  '/chat/start': 'chat-add-chatroom',
  [`/chat/${AUTO_CHAT_CHAT_ID}`]: 'chatroom-chat-feed',
  '/chat/:id': 'chatroom',
  '/chat/:id/media': 'media-library',
  '/chat/:id/search': 'chatroom-search',
  '/chat/user/:userId': 'chatroom-fake',
  '/audio/:messageId': 'audio-detail',
  '/freezone/model': 'freezone-pro',
  '/freezone/amateur': 'freezone-amateur',
  '/freezone/:messageId': 'flix-detail-freepeek',
  '/404': 'not-found',
  '/403': 'forbidden',
  '/geo-blocked': 'region-restrictions',
  '/error': 'went-wrong',
  '/events/lottery': 'lottery-event-list',
  '/events/assurance': 'dating-assurance-event-list',
  [`/join/${JoinProgress.PERSONAL_INFORMATION}`]: 'personal-information',
  [`/join/${JoinProgress.UPLOAD_IDENTIFICATION}`]: 'upload-identification',
  [`/join/${JoinProgress.OCR_PROCESSING}`]: 'kyc-review',
  [`/join/${JoinProgress.OCR_RESULT}`]: 'confirm-personal-information',
  [`/join/${JoinProgress.MANUAL_REVIEW}`]: 'manual-review',
  '/hashtag': 'recommended-hashtag',
  [`/age-verify/${JoinProgress.UPLOAD_IDENTIFICATION}`]:
    'user-upload-identification',
  [`/age-verify/${JoinProgress.OCR_PROCESSING}`]: 'user-kyc-review',
  '/post/:messageId': 'post-detail',
  '/post/:messageId/clip/:range': 'clip-shorts-detail',
  '/feed': 'feed',
  [`/manage-profile/${ManageProfileType.ACCOUNT}`]: 'manage-profile-account',
  [`/manage-profile/${ManageProfileType.MANAGE}`]: 'manage-profile-manage',
  '/manage-profile/username': 'edit-username',
  '/manage-profile/display-name': 'my-profile-edit-display-name',
  '/manage-profile/biography': 'my-profile-edit-biography',
  '/manage-profile/account-linking': 'my-profile-account-linking',
  '/manage-profile/account-linking/web-authn': 'my-profile-webauthn-link',
  '/manage-profile/blocked-list': 'my-profile-blocked-list',
  '/manage-profile/credit-card': 'my-profile-credit-card-information',
  '/manage-profile/credit-card/billing-email': 'my-profile-billing-email',
  [`/me/${ProfileListType.LIVESTREAM_SESSION}/:sessionId`]:
    'my-profile-livestream-session-list',
  [`/me/${ProfileListType.LIVESTREAM_SESSION}/:sessionId/leaderboard`]:
    'my-profile-livestream-session-leaderboard',
  '/archive': 'archive',
  '/revenue': 'revenue',
  '/revenue/report/daily': 'revenue-daily',
  '/revenue/report/fanleaderboard': 'revenue-fan-leaderboard',
  '/revenue/report/billing': 'revenue-billing',
  '/journal': 'journal',
  '/addvalue': 'addvalue',
  '/login': 'login',
  '/tos': 'tos',
  '/privacy': 'privacy',
  '/user-event': 'user-campaign-page',
  '/following': 'home-following',
};
